import { useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "@/components/base/Pagination";
import EmptyState from "@/components/base/EmptyState";
import { specials } from "@/mocks/specials";
import { paginate } from "@/utils/content";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const pageSize = 4;

export default function Special() {
  const [page, setPage] = useState(1);
  useDocumentMeta(
    "专题策划 - 午夜影院",
    "午夜影院专题策划，围绕悬疑、年代、科幻与青春等主题，整合作品推荐与编辑解读，帮你深度发现影视内容。"
  );

  const result = paginate(specials, page, pageSize);

  return (
    <div className="w-full bg-background-50">
      <section className="relative w-full overflow-hidden bg-primary-950">
        <span className="pointer-events-none absolute -right-6 top-1/2 hidden -translate-y-1/2 font-heading text-[130px] font-bold uppercase text-background-50/5 md:block">
          Special
        </span>
        <div className="relative mx-auto w-full max-w-[1280px] px-4 py-9 md:px-6 md:py-12">
          <nav aria-label="面包屑" className="flex items-center gap-2 text-xs text-background-400">
            <Link to="/" className="transition-colors duration-300 hover:text-secondary-300">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-background-200">专题策划</span>
          </nav>
          <div className="mt-4 flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="flex items-center gap-2 font-label text-[11px] font-semibold uppercase tracking-[0.22em] text-secondary-400">
                <span className="h-[2px] w-6 bg-accent-500" />
                Editorial Special
              </p>
              <h1 className="mt-2 font-heading text-2xl font-semibold tracking-tight text-background-50 md:text-[32px]">
                专题策划
              </h1>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-background-300/85">
                围绕一个主题，把散落的作品重新排列。每期专题都由编辑部撰写推荐理由，帮助你从另一个角度进入这些故事。
              </p>
            </div>
            <p className="font-label text-xs text-background-400">
              共 <span className="text-secondary-300">{specials.length}</span> 期专题
            </p>
          </div>
        </div>
      </section>

      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-12">
        {result.total === 0 ? (
          <EmptyState
            icon="ri-bookmark-3-line"
            title="暂无专题内容"
            description="编辑们正在准备新的专题，先去看看最新更新的影视作品吧。"
            actionLabel="浏览电影分类"
            actionTo="/category/movie"
          />
        ) : (
          <>
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6">
              {result.items.map((special) => (
                <article key={special.id} className="group">
                  <Link to={`/special/${special.id}`} className="block">
                    <div className="relative w-full overflow-hidden rounded-lg bg-primary-900">
                      <div className="aspect-[16/9] w-full">
                        <img
                          src={special.cover}
                          alt={`${special.title}专题封面`}
                          title={`${special.title} 午夜影院专题`}
                          className="h-full w-full object-cover object-center transition-transform duration-700 ease-smooth group-hover:scale-105"
                        />
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/35 to-transparent" />
                      <span className="absolute left-3 top-3 rounded-sm bg-secondary-500 px-2 py-1 font-label text-[10px] font-medium text-primary-950">
                        {special.month}
                      </span>
                      <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                        <h2 className="font-heading text-lg font-semibold text-background-50 md:text-xl">
                          {special.title}
                        </h2>
                        <p className="mt-1 text-xs text-background-200/85">{special.subtitle}</p>
                      </div>
                    </div>
                  </Link>
                  <div className="mt-3 flex items-start justify-between gap-4">
                    <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">
                      {special.intro}
                    </p>
                    <Link
                      to={`/special/${special.id}`}
                      className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs text-accent-700 transition-colors duration-300 hover:text-accent-600"
                    >
                      收录 {special.titleIds.length} 部
                      <i className="ri-arrow-right-up-line" />
                    </Link>
                  </div>
                </article>
              ))}
            </div>
            <Pagination page={result.page} totalPages={result.totalPages} onChange={setPage} />
          </>
        )}
      </div>
    </div>
  );
}